import React from 'react';
import RedirectOnce from './RedirectOnce';
import { SYSTEM_ERROR } from '../../api/redux-route/routes';
import { noticeError } from 'app/api/analytics/reporting';

export default class PrivateContentRenderer extends React.Component {
  state = {
    hasError: false,
  };

  static defaultProps = {
    innerProps: {},
  };

  componentDidCatch(e) {
    noticeError(e);
    this.setState({
      hasError: true,
    });
  }

  renderPrivateContent() {
    const ProtectedComponent = this.props.component;
    if (this.props.render) {
      return this.props.render(this.props.innerProps);
    } else {
      return <ProtectedComponent {...this.props.innerProps} />;
    }
  }

  renderRedirect() {
    return <RedirectOnce to={this.props.redirectTo} />;
  }

  render() {
    if (this.state.hasError) {
      return <RedirectOnce to={SYSTEM_ERROR} />;
    } else if (this.props.hasAccess) {
      return this.renderPrivateContent();
    }
    return this.renderRedirect();
  }
}



// WEBPACK FOOTER //
// ./src/app/ui/route/PrivateContentRenderer.js